module.exports = __webpack_public_path__ + "img/video-cover__tony.5542a173.jpg";